// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39IJH","questions":"styles_questions__PdJ73","footer":"styles_footer__1QP41"};